export default {
  formWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    '& > div': {
      maxWidth: 'none',
      margin: 0,
      padding: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
};
